import { useContext } from 'react';

import { SurveyCtx, SurveyCtxDispatch } from '@r1-frontend/survey/context';

const useCtxDispatch = (): SurveyCtxDispatch => {
    const { dispatch } = useContext(SurveyCtx);

    return dispatch;
};

export default useCtxDispatch;
